import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgPower = function SvgPower(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    size: size
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M20.444 9.86A.503.503 0 0020 9.6h-7.376l1.864-8.058a.475.475 0 00-.284-.544.513.513 0 00-.61.16l-10 13.44a.464.464 0 00-.041.501.503.503 0 00.447.261h7.376l-1.864 8.055a.475.475 0 00.284.543.513.513 0 00.611-.16l10-13.44a.464.464 0 00.037-.499z"
  }));
};

export default SvgPower;